<template>
  <div>
    <v-row class="mx-2">
      <v-col cols="12" xl="6" lg="6" md="6" sm="6" xs="12" class="px-0">
        <v-card-actions>
          <v-btn
            color="#FBB005"
            class="px-10"
            @click="
              visible = true;
              isEdit = false;
            "
          >
            <span class="subtitle-2 text-capitalize">Buat Device</span>
          </v-btn>
        </v-card-actions>
      </v-col>
      <v-col cols="12" xl="3" lg="3" md="3" sm="3" xs="12" class="px-0">
        <v-autocomplete
          placeholder="- Seluruh Unit Kerja - "
          v-model="unit_kerja_2_id"
          :items="units"
          :loading="loadingUnit"
          outlined
          dense
          hide-details
          clearable
          item-text="singkatan"
          item-value="unit_kerja_2_id"
          class="mx-2"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" xl="3" lg="3" md="3" sm="3" xs="12" class="px-0">
        <v-text-field
          placeholder="Cari"
          v-model="search"
          outlined
          dense
          hide-details
          clearable
          prepend-inner-icon="search"
          class="mx-2"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      id="table-custom"
      :headers="headers"
      :items="machines"
      :loading="loading"
      :options.sync="options"
      :server-items-length="totalItem"
      :footer-props="{
        'items-per-page-options': rowsPerPageItems
      }"
      loading-text="Loading... Please wait"
    >
      <template v-slot:[`item.ip`]="{ item }">
        <span>
          {{ item.alias_name ? item.alias_name : item.ip }}
          <!-- <v-icon class="ml-2" color="primary" small v-if="item.sync"
            >sync</v-icon
          > -->
        </span>
      </template>
      <template v-slot:[`item.online_offline`]="{ item }">
        <span
          :class="
            item.online_offline == 'Online' ? 'success-color' : 'subtitle-color'
          "
          >{{ item.online_offline }}</span
        >
      </template>
      <template v-slot:[`item.sync_terakhir`]="{ item }">
        <span v-html="item.sync_terakhir"></span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn block small color="primary" @click="handleEdit(item)">
          Ubah
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="visible" persistent max-width="400">
      <v-card class="pa-5 rounded-lg" id="card-custom">
        <v-btn @click="visible = false" x-small icon class="float-right">
          <v-icon>close</v-icon>
        </v-btn>
        <v-card-text class="subtitle-2 px-0 font-weight-regular">
          Add Device
        </v-card-text>
        <v-divider class="mb-4" />
        <v-form
          id="form"
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="save()"
        >
          <v-row>
            <v-col cols="5" class="py-1">
              <v-subheader class="caption headline-color font-weight-regular"
                >IP Address</v-subheader
              >
            </v-col>
            <v-col cols="7" class="py-1">
              <v-text-field
                v-model="form.ip"
                outlined
                dense
                hide-details
                :disabled="isEdit"
                :rules="[v => !!v || 'IP Address harus diisi']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" class="py-1">
              <v-subheader class="caption headline-color font-weight-regular"
                >Alias Name</v-subheader
              >
            </v-col>
            <v-col cols="7" class="py-1">
              <v-text-field
                v-model="form.alias_name"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" class="py-1">
              <v-subheader class="caption headline-color font-weight-regular"
                >Unit Kerja</v-subheader
              >
            </v-col>
            <v-col cols="7" class="py-1">
              <v-autocomplete
                v-model="form.unit_kerja_2_id"
                :items="units2"
                :loading="loadingUnit"
                outlined
                dense
                item-text="singkatan"
                item-value="unit_kerja_2_id"
                :rules="[v => !!v || 'Unit Kerja harus diisi']"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-card-actions class="mt-3">
            <v-spacer />
            <v-btn
              small
              outlined
              color="#717171"
              class="px-12"
              @click="visible = false"
              >Batal</v-btn
            >
            <v-btn
              small
              color="#FBB005"
              class="px-12 subtitle-2 text-capitalize"
              :loading="formLoading"
              type="submit"
              :disabled="!valid"
              form="form"
              >Simpan</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import MachineService from "@/services/resources/machine.service";
import PublicService from "@/services/resources/public.service";

export default {
  data() {
    return {
      visible: false,
      search: null,
      valid: false,
      loadingUnit: false,
      formLoading: false,
      status: [
        { text: "Ya", value: "Y" },
        { text: "Tidak", value: "N" }
      ],
      unit_kerja_2_id: null,
      units: [],
      units2: [],
      isEdit: false,
      headers: [
        {
          text: "IP Address/Name",
          value: "ip",
          sortable: false,
          align: "left"
        },
        // { text: "Status", value: "status", sortable: false, align: "left" },
        // {
        //   text: "Online/Offline",
        //   value: "online_offline",
        //   sortable: false,
        //   align: "left"
        // },
        {
          text: "Unit Kerja",
          value: "singkatan",
          sortable: false,
          align: "left"
        },
        {
          text: "Last Sync",
          value: "sync_terakhir",
          sortable: false,
          align: "left"
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "left"
        }
      ],
      form: {
        ip: null,
        alias_name: null,
        deviceid: null,
        unit_kerja_2_id: null,
        sync_terakhir: null
      },
      totalItem: 0,
      pageCount: 0,
      loading: true,
      options: {
        sortBy: ["ip"],
        sortDesc: [false]
      },
      rowsPerPageItems: [10, 20, 30, 40],
      machines: []
    };
  },
  watch: {
    options: {
      handler() {
        this.fetchListDebounce(this.getListMachine);
      },
      deep: true
    },
    paginationProperty: function() {
      this.options.page = 1;
      this.fetchListDebounce(this.getListMachine);
    },
    visible(val) {
      if (!val) {
        this.$refs.form.reset();
      }
    }
  },
  computed: {
    paginationProperty() {
      return [this.search, this.unit_kerja_2_id].join();
    }
  },
  methods: {
    handleEdit(item) {
      this.visible = true;
      this.isEdit = true;
      this.getDetailMachine(item.ip);
    },
    save() {
      if (this.$refs.form.validate()) {
        let formData = new FormData();
        formData.append("ip", this.form.ip);
        formData.append("alias_name", this.form.alias_name);
        formData.append("unit_kerja_2_id", this.form.unit_kerja_2_id);
        this.saveMachine(formData);
      }
    },
    // Service
    async getListUnit() {
      try {
        this.loadingUnit = true;
        await PublicService.getUnitKerjaList2(0)
          .then(response => {
            const { status, data } = response.data;
            if (status) {
              this.units2 = this.$_.cloneDeep(data);
              data.push({
                unit_kerja_2_id: null,
                singkatan: "- Semua Unit -"
              });
              this.units = data;
            }
          })
          .catch(error => {
            throw new Error(error);
          })
          .finally(() => (this.loadingUnit = false));
      } catch (err) {
        console.error(err);
      }
    },
    async getDetailMachine(NIP) {
      try {
        this.formLoading = true;
        await MachineService.getDetailDevice(NIP)
          .then(response => {
            const { status, data } = response.data;
            if (status) {
              this.form.ip = data.ip;
              this.form.alias_name = data.alias_name;
              this.form.deviceid = data.deviceid;
              this.form.unit_kerja_2_id = data.unit_kerja_2_id;
              this.form.sync_terakhir = data.sync_terakhir;
            }
          })
          .catch(error => {
            throw new Error(error);
          })
          .finally(() => (this.formLoading = false));
      } catch (err) {
        console.error(err);
      }
    },
    async saveMachine(payload) {
      try {
        this.formLoading = true;
        await MachineService.saveDevice(payload)
          .then(response => {
            const { status, message } = response.data;
            if (status) {
              this.visible = false;
              this.getListMachine();
              this.$store.commit("snackbar/setSnack", {
                show: true,
                message: message,
                color: "success"
              });
            } else {
              this.$store.commit("snackbar/setSnack", {
                show: true,
                message: message,
                color: "error"
              });
            }
          })
          .catch(error => {
            throw new Error(error);
          })
          .finally(() => (this.formLoading = false));
      } catch (err) {
        console.error(err);
      }
    },
    async getListMachine() {
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      let orderBy = [];
      sortBy.map((d, i) => {
        let sort = sortDesc[i] ? "desc" : "asc";
        orderBy = [...orderBy, d, sort];
        return d;
      });
      try {
        this.loading = true;
        await MachineService.getListDevice({
          filter: {
            search: this.search,
            unit_kerja_2_id: this.unit_kerja_2_id
          },
          orderBy,
          pageCurrent: page,
          dataPerPage: itemsPerPage
        })
          .then(response => {
            const { status, data } = response.data;
            const { list, pageTotal, countTotal } = data;
            if (status) {
              let machines = list;
              machines.map((data, index) => {
                data.no = itemsPerPage * (page - 1) + (index + 1);
                return data;
              });

              this.machines = machines;
              this.totalItem = parseInt(countTotal);
              this.pageCount = parseInt(pageTotal);
            }
          })
          .catch(error => {
            throw new Error(error);
          })
          .finally(() => (this.loading = false));
      } catch (err) {
        console.error(err);
      }
    }
  },
  mounted() {
    this.getListUnit();
    this.getListMachine();
  }
};
</script>
<style lang="scss">
#table-custom.v-data-table {
  color: #717171 !important;
  .v-data-table__wrapper > table > thead {
    background-color: #fdfdfd;
  }
  .v-data-table__wrapper > table > thead > tr > th {
    font-size: 0.775rem;
    font-weight: 400;
  }
  .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 0.775rem;
  }
}
#card-custom .v-input {
  font-size: 0.775rem;
}
#btn-type .v-btn--contained {
  background-color: #ffffff !important;
  .v-btn__content {
    color: #717171 !important;
  }
}
#btn-type .v-btn--active {
  background-color: #1792e6 !important;
  .v-btn__content {
    color: #ffffff !important;
  }
}
</style>
